import { render, staticRenderFns } from "./ProjectCase.vue?vue&type=template&id=ca06d4c0&scoped=true&"
import script from "./ProjectCase.vue?vue&type=script&lang=js&"
export * from "./ProjectCase.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCase.vue?vue&type=style&index=0&id=ca06d4c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca06d4c0",
  null
  
)

export default component.exports